export const logAnalyticsEvent = async ({postData, platform}) => {
    return fetch('https://novel-analytics-api.pocketnovel.com/v2/logging_data/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        platform,
      },
      body: JSON.stringify(postData),
    })
  }